export enum FilterHeaderSize {
  HEADING_500 = 500,
  HEADING_300 = 300
}

export enum FilterHeaderWeight {
  BOLD = 'bold'
}

export enum FilterHeaderLevel {
  LEVEL_1 = 1
}
